import React, { FunctionComponent, useState } from "react"
import { locale, DropDown, DropDownItem } from "@albelli/photoselector"
import sortingIcon from "@albelli/photoselector/lib/ImagePicker/Graphic/sorting-icon.svg"

interface SortingSelectorProps {
  sortingDirection?: string
  handleSortingChange?: any
  sortingField?: string
}

interface SortingDropDownItem extends DropDownItem {
  field: string
  sort: string
  canShow: boolean
}

const SortingSelector: FunctionComponent<SortingSelectorProps> = ({ sortingField, handleSortingChange }) => {
  const { generic } = locale.get()
  const options: SortingDropDownItem[] = [
    { id: "newestfirst", field: "CollectionCreateDate", sort: "Descending", title: generic.newestfirst, canShow: Boolean(sortingField) },
    { id: "oldestfirst", field: "CollectionCreateDate", sort: "Ascending", title: generic.oldestfirst, canShow: Boolean(sortingField) },
    { id: "generic.az", field: "CollectionName", sort: "Ascending", title: generic.az, canShow: Boolean(sortingField) },
    { id: "generic.za", field: "CollectionName", sort: "Descending", title: generic.za, canShow: Boolean(sortingField) },
    { id: "newestfirst", field: "", sort: "Descending", title: generic.newestfirst, canShow: !Boolean(sortingField) },
    { id: "oldestfirst", field: "", sort: "Ascending", title: generic.oldestfirst, canShow: !Boolean(sortingField) }
  ]

  const sortedOptions = options.filter((option) => option.canShow)

  const [selected, setSelected] = useState<DropDownItem | undefined>(sortedOptions[0])

  const onSelect = (item: DropDownItem) => {
    const selectedItem = item as SortingDropDownItem
    setSelected(selectedItem)
    handleSortingChange(selectedItem.sort, selectedItem.field)
  }

  return (
    <DropDown list={sortedOptions} selectedId={selected?.id} className="sorting" onSelect={onSelect} position="bottom">
      <div className="photoselector-filter-component dropdown-label sorting photoselector-sort-value" data-tam="sorting-filter">
        <img className="photoselector-dropdown-icon" src={sortingIcon} />
        {selected ? selected.title : ""}
      </div>
    </DropDown>
  )
}

export default SortingSelector
